"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toast = exports.useToast = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
require("./Toast.css");
var Notification_1 = require("../../components/Notification");
var R = __importStar(require("../../utils/ramda"));
var react_2 = require("react");
var react_dom_1 = require("react-dom");
var faker_1 = __importDefault(require("../../utils/faker"));
var css_1 = require("@emotion/css");
var classnames_1 = __importDefault(require("classnames"));
var isType_1 = require("../../utils/isType");
var useToast = function (top) {
  if (top === void 0) {
    top = false;
  }
  var _a = __read((0, react_2.useState)([]), 2),
    dismissed = _a[0],
    setDismissed = _a[1];
  var _b = __read((0, react_2.useState)({}), 2),
    heights = _b[0],
    setHeights = _b[1];
  var _c = __read((0, react_2.useState)([]), 2),
    toasts = _c[0],
    setToasts = _c[1];
  var toastIds = toasts.map(function (t) {
    return t.id;
  });
  var dismiss = function (id) {
    if (id) {
      setDismissed(R.append(id));
      setTimeout(function () {
        setToasts(R.reject(function (v) {
          return v.id === id;
        }));
        setDismissed(R.reject(function (s) {
          return s === id;
        }));
      }, 150);
    } else {
      setDismissed(R.concat(toastIds));
      setTimeout(function () {
        setDismissed([]);
        setToasts([]);
      }, 150);
    }
  };
  var show = (0, react_2.useCallback)(function (options) {
    var id = faker_1.default.guid();
    setToasts(R.append({
      id: id,
      options: options
    }));
    if (options.duration && options.duration > 0 && !(0, isType_1.isInfinity)(options.duration)) {
      setTimeout(function () {
        return dismiss(id);
      }, options.duration);
    }
    return id;
  }, []);
  (0, react_2.useLayoutEffect)(function () {
    var e_1, _a;
    var _b, _c;
    try {
      for (var toasts_1 = __values(toasts), toasts_1_1 = toasts_1.next(); !toasts_1_1.done; toasts_1_1 = toasts_1.next()) {
        var toast = toasts_1_1.value;
        var v = heights[toast.id];
        if (!v) {
          var height = (_c = (_b = document.querySelector("[data-toastid=\"".concat(toast.id, "\"]"))) === null || _b === void 0 ? void 0 : _b.clientHeight) !== null && _c !== void 0 ? _c : 0;
          setHeights(R.assoc(toast.id, height));
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (toasts_1_1 && !toasts_1_1.done && (_a = toasts_1.return)) _a.call(toasts_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }, [toasts]);
  var toaster = (0, react_2.useMemo)(function () {
    return (0, jsx_runtime_1.jsx)("div", __assign({
      className: (0, classnames_1.default)("vsx-toaster", "vsx-toaster-".concat(top ? "top" : "bottom"))
    }, {
      children: toasts.map(function (o, idx) {
        var yPos = [0].concat(toasts.slice(0, idx).map(function (v) {
          return heights[v.id];
        })).reduce(function (a, b) {
          return a + b;
        });
        var yGap = 8;
        var multiplier = top ? 1 : -1;
        var transformPercentage = top ? "0%" : "-100%";
        var yOffset = (yPos + idx * yGap) * multiplier;
        return (0, react_1.createElement)(exports.Toast, __assign({}, o.options, {
          key: o.id,
          "data-toastid": o.id,
          className: (0, classnames_1.default)(dismissed.includes(o.id) && "vsx-toast-dismissed"),
          onDismiss: function () {
            o.options.onDismiss && o.options.onDismiss();
            dismiss(o.id);
          },
          style: {
            left: "50%",
            transform: "translateX(-50%) translateY(calc(".concat(transformPercentage, " + ").concat(yOffset, "px))")
          }
        }));
      })
    }));
  }, [top, toasts, dismiss, dismissed]);
  var mount = (0, react_2.useMemo)(function () {
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
      children: (0, react_dom_1.createPortal)(toaster, document.body)
    });
  }, [toaster]);
  var returnArray = (0, react_2.useMemo)(function () {
    var arr = [mount, show, dismiss];
    return arr;
  }, [mount, show, dismiss]);
  return returnArray;
};
exports.useToast = useToast;
var Toast = function (options) {
  var _a = R.omit(["duration", "position"], options),
    _b = _a.dismissible,
    dismissible = _b === void 0 ? true : _b,
    style = _a.style,
    className = _a.className,
    message = _a.message,
    type = _a.type,
    onDismiss = _a.onDismiss,
    restProps = __rest(_a, ["dismissible", "style", "className", "message", "type", "onDismiss"]);
  return (0, jsx_runtime_1.jsx)(Notification_1.Notification, __assign({}, restProps, {
    style: style,
    type: type,
    shadow: "large",
    dismissible: dismissible,
    onDismiss: onDismiss,
    className: (0, css_1.cx)("vsx-toast", className),
    padding: "large",
    borderLeft: true
  }, {
    children: message
  }));
};
exports.Toast = Toast;